<template>
  <iframe
    v-if="isPdf"
    :src="`https://drive.google.com/viewerng/viewer?embedded=true&url=${Weblink}`"
    height="100%"
    width="100%"
    frameBorder="0"
  ></iframe>
  <iframe
    v-else
    :src="Weblink"
    height="100%"
    width="100%"
    frameBorder="0"
  ></iframe>
</template>

<script>
const Url = require("url-parse");

export default {
  props: {
    Weblink: String,
  },
  computed: {
    /**
     * Check if url contains a .pdf file,
     * if it does, use gdrive workaround to
     * display them on iOS correctly too
     */
    isPdf() {
      return Url(this.Weblink).pathname.endsWith(".pdf");
    },
  },
};
</script>
